function closingDelimiter(source: string, start: number, open: string, close: string, quotedAttributes = false): number {
  let depth = 1;
  let quote = '';
  for (let index = start + 1; index < source.length; index++) {
    const character = source[index];
    if (character === '\\') {
      index++;
      continue;
    }
    if (quotedAttributes && (character === '"' || character === "'")) {
      if (!quote) quote = character;
      else if (quote === character) quote = '';
    }
    if (quote) continue;
    if (character === open) depth++;
    if (character === close) {
      depth--;
      if (depth === 0) return index;
    }
  }
  return source.length;
}

function publicLabel(attributes: string): string {
  const attribute = /(?:^|\s)([\w-]+)\s*=\s*(?:"((?:\\.|[^"\\])*)"|'((?:\\.|[^'\\])*)'|([^\s]+))/g;
  let match: RegExpExecArray | null;
  while ((match = attribute.exec(attributes)) !== null) {
    if (match[1] === 'label') return (match[2] ?? match[3] ?? match[4]).replace(/\\(.)/g, '$1');
  }
  return '';
}

export function maskSecretFields(source: string, placeholder: string, formatLabel = (label: string) => label): string {
  const directive = /:{1,3}secret\[/g;
  let result = '';
  let offset = 0;
  let match: RegExpExecArray | null;
  while ((match = directive.exec(source)) !== null) {
    const bracket = directive.lastIndex - 1;
    const bracketEnd = closingDelimiter(source, bracket, '[', ']');
    let end = Math.min(bracketEnd + 1, source.length);
    let label = '';
    if (source[end] === '{') {
      const attributesEnd = closingDelimiter(source, end, '{', '}', match[0] === ':secret[');
      if (bracketEnd < source.length && attributesEnd < source.length) {
        label = match[0] === ':secret['
          ? publicLabel(source.slice(end + 1, attributesEnd))
          : match[0] === '::secret[' ? source.slice(bracket + 1, bracketEnd).replace(/\\(.)/g, '$1') : '';
      }
      end = Math.min(attributesEnd + 1, source.length);
    }
    while (source[end] === ':') end++;
    result += source.slice(offset, match.index) + (label ? `${formatLabel(label)}: ` : '') + placeholder;
    offset = end;
    directive.lastIndex = end;
  }
  return result + source.slice(offset);
}
